import React, { useEffect, useState } from "react";
import AddToCartButton from "../AddToCartButton/AddToCartButton";
import { useNavigate } from "react-router-dom";
import "./Enrolllink.css";

export default function EnrollButton({
  
  courseId,
  levelId,
  amount,
  levelbadge,
  courseTitle,
  disabled, // ✅ new prop
  onClick, // ✅ new prop
}) {
    const navigate = useNavigate(); // if not already defined

  const handleClick = (e) => {

  if (disabled) {
    e.preventDefault();
    e.stopPropagation();
    
    // Show alert, then redirect after user clicks OK
    alert("Please complete your profile first!");
    navigate("/registerprofile"); // redirect to profile page
    return;
  }

  // Call parent onClick if provided
  if (onClick) onClick(e);
};

  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (!user?.uid) {
      setLoading(false);
      return;
    }

    fetch(`https://agepcoatings.com/payments/userpurchases/${user.uid}`)
      .then((res) => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then((data) => {
        if (data.success) setPurchases(data.purchases);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setLoading(false);
      });
  }, [user]);

  if (loading) return null;
  // Hide Enroll button if user already fully or partially paid for this course/level
  const hasPaid = purchases.some(
    (p) =>
      p.courseId === courseId &&
      p.levelId === levelId &&
      (p.paymentType === "full" || p.paymentType === "partial")
  );

  if (!user?.uid || hasPaid) return null;

  return (
    <AddToCartButton
      courseId={courseId}
      levelId={levelId}
      courseTitle={courseTitle}
      amount={amount}
      levelbadge={levelbadge}
      mode="full"
      asLink={false}
      className="enroll-button text-center rounded-5 w-100 border-0"
      style={{ textDecoration: "none", color: "#fef5ee", cursor: "pointer", }}
      onClick={(e) => handleClick(e)}
    >
      Enroll Now
    </AddToCartButton>
  );
}
